import development from './development.json';
import stage from './stage.json';
import production from './production.json';

/**
 * Host-driven environment config.
 *
 * Backend selection is a function of the serving hostname: one build is
 * deployed to every environment, and the domain it is served from selects
 * which backend config (sherlockGQL, loginURL, appHost, …) it uses. This
 * lets a single artifact self-configure for prod/stage/dev and for the
 * per-backend release preview subdomains (`release-<slug>.dashboard[.stage|.dev].myf2b.com`).
 *
 * Falls back to `development` for localhost and non-browser (SSG/build)
 * contexts — the least-privileged backend. Deployed hosts always match one
 * of the three patterns, and the primary `/graphql` client is same-origin so
 * it follows the serving distribution regardless of this resolver.
 */
export const resolveEnv = (
  host = typeof window !== 'undefined' ? window.location.hostname : '',
) => {
  if (/(^|\.)stage\.myf2b\.com$/.test(host)) return stage;
  if (/(^|\.)dev\.myf2b\.com$/.test(host)) return development;
  if (/(^|\.)myf2b\.com$/.test(host)) return production;
  return development;
};

export const getEnv = () => resolveEnv();

export default getEnv;
